<template>
  <div class="min-h-screen  pt-24 pb-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-4xl mx-auto">
      <div class="text-center mb-12">
        <h1 class="font-heading text-4xl md:text-5xl font-bold text-white mb-4 drop-shadow-[0_0_15px_rgba(0,242,255,0.3)]">
          Frequently Asked Questions
        </h1>
        <p v-if="data?.intro" class="text-text-muted text-lg max-w-2xl mx-auto whitespace-pre-line">
          {{ data.intro }}
        </p>
      </div>

      <div class="bg-[#15161a] border border-white/5 rounded-lg p-6 md:p-10 shadow-2xl backdrop-blur-sm relative overflow-hidden">
        <div class="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-[100px] pointer-events-none"></div>
        <div class="absolute bottom-0 left-0 w-64 h-64 bg-accent/5 rounded-full blur-[100px] pointer-events-none"></div>

        <!-- Loading -->
        <div v-if="pending" class="flex justify-center py-20">
          <div class="w-10 h-10 border-3 border-white/10 border-t-primary rounded-full animate-spin"></div>
        </div>

        <!-- Empty -->
        <div v-else-if="!data?.items?.length" class="text-center py-20 text-text-muted">
          <p class="text-lg">No questions have been published yet.</p>
          <p class="text-sm mt-2">Check back soon — or get in touch via the contact page.</p>
        </div>

        <!-- Accordion -->
        <div v-else class="relative divide-y divide-white/5">
          <details
            v-for="(item, idx) in data.items"
            :key="idx"
            class="group py-4 md:py-5"
          >
            <summary class="list-none cursor-pointer flex items-start gap-4 select-none">
              <span class="flex-shrink-0 mt-0.5 w-7 h-7 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-primary transition-transform group-open:rotate-45">
                <span class="block w-3 h-3 relative">
                  <span class="absolute inset-x-0 top-1/2 h-[2px] -translate-y-1/2 bg-current"></span>
                  <span class="absolute inset-y-0 left-1/2 w-[2px] -translate-x-1/2 bg-current"></span>
                </span>
              </span>
              <h3 class="font-heading text-base md:text-lg font-semibold text-white leading-snug pt-0.5">
                {{ item.question }}
              </h3>
            </summary>
            <div class="pl-11 pt-3 pr-2 text-text-dim leading-relaxed whitespace-pre-line">{{ item.answer }}</div>
          </details>
        </div>
      </div>

      <div class="mt-8 text-center text-sm text-text-muted">
        Still need help?
        <NuxtLink :to="localePath('/contact')" class="text-primary hover:underline font-semibold">Contact us</NuxtLink>.
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  title: 'FAQ'
})

const localePath = useLocalePath()
const { data, pending } = await useFetch('/api/public/faq')

// Pick the shell layout based on the subdomain the user is on — matches
// about.vue so FAQ shows up inside the admin / creator chrome when
// opened from those panels.
const url = useRequestURL()
const host = url.hostname
if (host.startsWith('admin.')) {
  setPageLayout('admin')
} else if (host.startsWith('creator.')) {
  setPageLayout('creator')
}
</script>
